import $ from 'jquery';
import '@chenfengyuan/datepicker';
import '@chenfengyuan/datepicker/i18n/datepicker.hu-HU';
import "@chenfengyuan/datepicker/src/css/datepicker.scss";

$.fn.datepicker.setDefaults({
    language: 'hu-HU'
});
